import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { ValidationService } from '../../../shared/services/validation.service';
import { InvoiceListModel } from '../../../models/payment/invoice.model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { InvoiceUrl } from '../../../shared/urls/invoice.url';
import { PriceUrl } from '../../../shared/urls/price.url';
import { Utility } from '../../../common/utility';
import { OrganizationUrl } from '../../../shared/urls/company-account.url';
import { CentreUrl } from '../../../shared/urls/centre.url';

@Injectable()
export class AccountPaymentService {
  constructor(public baseService: BaseService) {

  }

  getSearchType() {
    const url = InvoiceUrl.GET_SEARCH_TYPE;
    return this.baseService.getData(url);
  }

  getDefaultCurrency(centreId) {
    const url = CentreUrl.GET_CENTRE + `/${centreId}`;
    return this.baseService.getData(url);
  }
  getCurrencies() {
    const url = InvoiceUrl.GET_CURRENCY_ACCOUNTPAYMENT;
    return this.baseService.getData(url);
    // return [
    //   {
    //     id: "2",
    //     code: "EUR",
    //     name: "Euro",
    //     symbol: "€",
    //     symbolPosition: "L",
    //     rate: 1
    //   },
    //   {
    //     id: "3",
    //     code: "GBP",
    //     name: "British Pound",
    //     symbol: "£",
    //     symbolPosition: "L",
    //     rate: 1
    //   },
    //   {
    //     id: "4",
    //     code: "ZAR",
    //     name: "South African Rand",
    //     symbol: "R",
    //     symbolPosition: "L",
    //     rate: 1
    //   }
    // ];
 }

 getInvoiceList(param) {
   let url = InvoiceUrl.GET_LIST_INVOICE;
   return this.baseService.getData(url, param);
 }

 getUserInfor(param) {
   const url = InvoiceUrl.GET_USERINFOR;
   return this.baseService.getData(url, param);
 }

 getCreditNote(param) {
  const url = InvoiceUrl.GET_LIST_CREDIT;
   return this.baseService.getData(url, param);
 }

 allocateCreditNote(invoiceId, creditNoteId) {
   const url = Utility.stringFormat(InvoiceUrl.ALLOCATE_CREDITNOTE, [invoiceId, creditNoteId]);
   return this.baseService.put(url, null);
 }

 addCreditNote(invoiceId, param) {
   const url = Utility.stringFormat(InvoiceUrl.ADD_ACCOUNTPAYMENT_CREDITNOTE, [invoiceId]);
   return this.baseService.postData(url, param);
 }

 addOrderNumber(param) {
   const url = InvoiceUrl.ADD_ORDER_NUMBER_INVOICE;
   return this.baseService.postData(url, param);
 }

 updateBadDebt(invoiceId) {
   const url = Utility.stringFormat(InvoiceUrl.UPDATE_INVOICE_BADDEBT, [invoiceId]);
   return this.baseService.put(url, null);
 }

 getPaymentType() {
   const url = InvoiceUrl.GET_ACCOUNT_PAYMENT_METHOD;
   return this.baseService.getData(url);
 }

 payInvoice(param) {
   const url = InvoiceUrl.PAY_INVOICE;
   return this.baseService.postData(url, param);
 }

 refundInvoice(invoiceId, param) {
   const url = Utility.stringFormat(InvoiceUrl.REFUND_INVOICE, [invoiceId]);
   return this.baseService.postData(url, param);
 }

 updateWithHoldingTax(invoiceId, param) {
   const url = Utility.stringFormat(InvoiceUrl.UPDATE_WITHHOLDING_TAX, [invoiceId]);
   return this.baseService.put(url, param);
 }

 receivedTax(invoiceId) {

   let url = InvoiceUrl.RECEIVED_TAX;
   return this.baseService.put(url, invoiceId);
 }

 getListOrganization() {
   let url = InvoiceUrl.GET_ALL_ORGANIZATION;
   return this.baseService.getData(url);
 }

 getCentre() {
   let url = InvoiceUrl.GET_CENTRE_ACCOUNT_PAYMENT;
   return this.baseService.getData(url);
 }

 getCentreGroup() {
  let url = InvoiceUrl.GET_CENTRE_GROUP;
  return this.baseService.getData(url);
}

 getOrganizationDetail(organizationId) {
   return this.baseService.getById(OrganizationUrl.ORGANIZATION_GET, organizationId);
 }

  validateDateRange(fromDateControl, toDateControl, isFromDateActive) {
      if (ValidationService.isValidDate(fromDateControl) || ValidationService.isValidDate(toDateControl)) {
          return;
      }
      // validate fromDate < toDate
      if (ValidationService.compareDate(fromDateControl, toDateControl) === 1) {
          if (isFromDateActive) {
              fromDateControl.setErrors({'invalidDateAccountPayment': true});
          } else {
              toDateControl.setErrors({'invalidDateAccountPayment': true});
          }

      } else {
        fromDateControl.setErrors(null);
        toDateControl.setErrors(null);
      }

  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/payment/account-payment/account-payment.service.ts